import {Component, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";
import {PerfilComponent} from "../perfil/perfil.component";

@Component({
    selector: 'app-perfil-detail',
    templateUrl: '../perfil/perfil.component.html',
    styleUrls: ['./perfil-detail.component.css']
})
export class PerfilDetailComponent extends PerfilComponent implements OnInit {

    id:number;
    perfilsys:any;

    ngOnInit() {
		if (!this.isAdmin())
            this.router.navigateByUrl('inicio');
		else {
			this.route.params.subscribe(params => this.id = +params['id']);
			this.perfilService.get_id(this.id)
				.then((
					perfil)=>this.setperfil(perfil)
				);
		}
    }

    onSubmit() {
        this.perfilService.update(this.perfilsys)
            .then(() => this.goBack());
    }

}



// WEBPACK FOOTER //
// ./src/app/perfil-detail/perfil-detail.component.ts